(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    const lockOpenAboutMenu = (root = document) => {
    root.querySelectorAll('.menu-drawer__menu-container--always-open').forEach((menu) => {
      menu.open = true;

      if (menu.dataset.alwaysOpenBound === 'true') return;

      menu.dataset.alwaysOpenBound = 'true';
      menu.addEventListener('toggle', () => {
        if (!menu.open) requestAnimationFrame(() => { menu.open = true; });
      });
    });
  };

  lockOpenAboutMenu();
  document.addEventListener('shopify:section:load', (event) => lockOpenAboutMenu(event.target));
  } catch(e) { console.error(e); }
})();

})();
